module.exports = __webpack_public_path__ + "files/1e7ff86fc42e93f5d2d1e3cb909fbd1b.png";